import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import ModalComponent from  '../../../components/ModalComponent';
import { FaShoppingCart } from "react-icons/fa";
import { Card, CardBody, Table } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ListOrderComponent from "../../../components/Admin/orders/ListOrderComponent";
import PaginateComponent from "../../../components/PaginateComponent";

class ListOrderWaitingPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listOrder: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            userId: 0,
            typeOrder: '',
            status: 'Waiting',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListOrder();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListOrder = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?userId=" + this.state.userId + "&typeOrder=" + this.state.typeOrder + "&status=" + this.state.status;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/getListOrder' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listOrder: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    changeQtt = (event) => {
        this.setState({
            userId: event.target.value
        })
        this.getListOrder();
    }

    changeTypeOrder = (event) => {
        // console.log(event.target.value)
        this.search({
            typeOrder: event.target.value
        })
        this.getListOrder();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?userId=" + this.state.userId + "&typeOrder=" + this.state.typeOrder + "&status=" + this.state.status + "&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/getListOrder' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listOrder: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    screentListOrder = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listOrder.length ) {
                return (
                    this.state.listOrder.map( (order, key) => {
                        return (
                            <ListOrderComponent
                                key={key}
                                order={order}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có đơn hàng trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    showModal = (actionKey, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'infoOrder' ) {
            titleModal = 'Chi tiết đơn dặt hàng';
            modalBody = this.modalBody(actionKey, action);
        }
        else if ( action === 'deleteOrder' ) {
            titleModal = 'Xóa đơn dặt hàng';
            modalBody = this.modalBody(actionKey, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: actionKey
        })
    }

    hiddenModal = () => {
        this.setState({
            actionKey: 0,
            action: '',
            isModal: false,
        })
    }

    modalBody = (actionKey, action) => {
        if ( action === 'deleteOrder' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa đơn đặt hàng này không này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về đơn hàng này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
        else if ( action === 'infoOrder' ) {
            return (
                <>
                    <div className="detail_order text-center">
                        <div className="paid">
                            { this.loadStatusOrder(actionKey) }
                        </div>
                        <div className="date_due">
                            Ngày đặt hàng: <b>{ this.state.listOrder[actionKey].text_date_create }</b>
                        </div>
                        <div className="date_due">
                            {
                                this.state.listOrder[actionKey].status === 'Finish'
                                || this.state.listOrder[actionKey].status === 'Waiting' ? (
                                    <div className="text-success">
                                        Ngày thanh toán: <b>{ this.state.listOrder[actionKey].text_date_paid }</b>
                                    </div>
                                ) : (
                                    <div className="text-danger">
                                        Chưa thanh toán
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className="detail_order">
                        <div>Thông tin dịch vụ / sản phẩm</div>
                        <div className="m-3">
                            <Table className="table table-sm table-bordered table-hover rounded text-center">
                                <thead className="primay">{ this.loadHeadInfoOrder() }</thead>
                                <tbody>{ this.loadBodyInfoOrder }</tbody>
                            </Table>
                        </div>
                    </div>
                </>
            )
        }
    }

    loadStatusOrder = (actionKey) => {
        if ( this.state.listOrder[actionKey].status === 'Finish' ) {
            return (
                <span className="text-success">Đã thanh toán</span>
            )
        }
        else if ( this.state.listOrder[actionKey].status === 'Waiting' ) {
            return (
                <span className="text-info">Thanh toán chờ</span>
            )
        }
        else if ( this.state.listOrder[actionKey].status === 'Pending' ) {
            return (
                <span className="text-danger">Chưa thanh toán</span>
            )
        }
        else if ( this.state.listOrder[actionKey].status === 'Cancel' ) {
            return (
                <span className="text-danger">Hủy</span>
            )
        }
    }

    loadHeadInfoOrder = (actionKey) => {

    }

    loadBodyInfoOrder = (actionKey) => {

    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Quản lý đơn hàng"} page={"Đơn hàng"} icon={<FaShoppingCart className="breadcrumb-icon"/>} />
                            <Card>
                                <CardBody className="table-responsive">
                                    <div className="col-12">
                                        <Link className="btn btn-success" to="/admin/don-dat-hang/tao-don-hang">
                                            Tạo đơn hàng
                                        </Link>
                                    </div>
                                    <div className="dataTables_wrapper form-inline dt-bootstrap">
                                        <div className="list-group-email row">
                                            <div className="col-md-12">
                                                {
                                                    this.checkNotification()
                                                }
                                            </div>
                                            <div className="col col-md-12">
                                                <Table className="table table-sm table-bordered table-hover rounded text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Ngày đặt hàng</th>
                                                            <th>Khách hàng</th>
                                                            <th>Tổng tiền</th>
                                                            <th>Loại</th>
                                                            <th>Chi tiết</th>
                                                            <th>Trạng thái</th>
                                                            <th>Hành động</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        { this.screentListOrder() }
                                                    </tbody>
                                                </Table>
                                                { this.paginate() }
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminOrderWaiting' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListOrderWaitingPage);